const key = 'streamit.household-invitation.v1';
const tokenPattern = /^[A-Za-z0-9_-]{43}$/;
type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
const storage = () => sessionStorage;
export function readInvitation(getStore: () => Store = storage, now = Date.now()): string | undefined {
  try {
    const item = JSON.parse(getStore().getItem(key) || 'null');
    if (item && tokenPattern.test(item.token) && item.expiresAt > now && item.expiresAt <= now + 86_400_000) return item.token;
    getStore().removeItem(key);
  } catch { /* A blocked or malformed store cannot authorize an invitation. */ }
}
export function captureInvitation(href: string, getStore: () => Store = storage, now = Date.now()): string | undefined {
  const url = new URL(href);
  if (url.pathname !== '/invite' || !url.hash) return;
  const token = new URLSearchParams(url.hash.slice(1)).get('token');
  clearInvitation(getStore);
  if (!token || !tokenPattern.test(token)) return;
  try { getStore().setItem(key, JSON.stringify({ token, expiresAt: now + 86_400_000 })); } catch { /* Still usable in this page while signed in. */ }
  return token;
}
export function clearInvitation(getStore: () => Store = storage) {
  try { getStore().removeItem(key); } catch { /* Storage may be disabled. */ }
}
